import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ApiClientConstant } from '@cureskin/api-client';
import { ExperimentService } from '@services/experiment/experiment.service';

export const checkoutGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const experimentService = inject(ExperimentService);

  const { type, regimenId } = route.queryParams;

  const isRegimenOrder = type === ApiClientConstant.Order.Type.REGIMEN;
  const isReviewOrderExperimentEnabled = experimentService.reviewOrderPageExperiment?.enable;
  const shouldNavigateToReviewOrderPage = isRegimenOrder && regimenId && isReviewOrderExperimentEnabled;

  if (shouldNavigateToReviewOrderPage) {
    return router.createUrlTree(['/review-order'], { queryParams: route.queryParams });
  }

  return true;
};
